import { useEffect, useState } from "react";
import { Ticket } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";

const STATUS = { Valido: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30", Riscattato: "bg-slate-500/15 text-slate-300 border-slate-500/30", Scaduto: "bg-red-500/15 text-red-400 border-red-500/30" };

export function MyDiscounts() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.customerDiscounts().then(setRows).catch(() => setRows([])); }, []);
  if (!rows || rows.length === 0) return null;
  return (
    <section className="space-y-2" data-testid="my-discounts">
      <h2 className="text-base md:text-lg font-semibold flex items-center gap-2"><Ticket className="h-4 w-4 text-emerald-400" /> I miei codici sconto</h2>
      {rows.map((d) => (
        <Card key={d.code} className={`p-4 bg-card border-border ${d.status !== "Valido" ? "opacity-60" : ""}`} data-testid={`my-discount-${d.code}`}>
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-mono-code font-bold text-lg tracking-wider">{d.code}</span>
            <Badge className={`border ${STATUS[d.status] || ""}`} data-testid={`my-discount-status-${d.code}`}>{d.status}</Badge>
            <span className="text-xs text-muted-foreground ml-auto">{d.status === "Riscattato" ? `Riscattato presso ${d.redeemed_store_name}` : `Scade il ${d.expires_at_local}`}</span>
          </div>
          <p className="text-sm mt-1">{d.description}</p>
          <p className="text-xs text-muted-foreground">{d.campaign_name} · mostra il codice in cassa</p>
        </Card>
      ))}
    </section>
  );
}
